module.exports = __webpack_public_path__ + "static/media/13.5068695a.jpg";